import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  setSharedDashboard,
  dashboardSnapshotValidator,
} from '@/widgets/dashboards';
import type { DashboardSnapshot } from '@/widgets/dashboards';
import { ImportSharedPreset } from '@/features/SharePreset';
import { ROUTES } from '@/shared/constants';
import { Analytics } from '@/shared/lib';
import { useAppDispatch } from '@/shared/model';

export function ImportSharedViewDialog() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isPresetValid = useCallback((preset: unknown) => {
    return dashboardSnapshotValidator.safeParse(preset).success;
  }, []);

  const handleApplyPreset = useCallback(
    (preset: unknown) => {
      const snapshot = preset as DashboardSnapshot;
      dispatch(setSharedDashboard(snapshot));
      Analytics.sendFeatureUsage('shared_preset', 'apply');
      navigate(`${ROUTES.dashboards}/preview`);
    },
    [dispatch, navigate],
  );

  return (
    <ImportSharedPreset
      isPresetValid={isPresetValid}
      applyPreset={handleApplyPreset}
      onPresetError={() => {}}
    />
  );
}
